import { render, staticRenderFns } from "./CreationRequest.vue?vue&type=template&id=4b863214&"
import script from "./CreationRequest.ts?vue&type=script&lang=ts&"
export * from "./CreationRequest.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports